import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const Delete = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [visible, setVisible] = useState(true);
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.QUALIFIERS.LIST.path);
  const [deleteQualifier] = useMutation(graphql.mutations.DELETE_QUALIFIER, {
    refetchQueries: [
      {
        query: graphql.queries.QUALIFIERS,
        awaitRefetchQueries: true,
        variables: INITIAL_VALUES,
      },
    ],
    onCompleted: () => {
      setVisible(false);
      navigate(SCREENS.PRIVATE.ADMIN.QUALIFIERS.LIST.path, { replace: true });
    },
    onError: () => {},
  });

  const onSubmit = () => {
    return deleteQualifier({
      variables: {
        where: {
          id,
        },
      },
    });
  };
  return <View onSubmit={onSubmit} cancel={cancel} visible={visible} />;
};

export default Delete;
